import axios from '../api'

export default {
  /**
   * 获取员工列表
   */
  getStaffList: data => {
    return axios({
      url: '/protected/account/list',
      method: 'post',
      data
    })
  },
  /**
   * 保存员工信息
   */
  saveStaffInfo: data => {
    return axios({
      url: '/protected/account/save',
      method: 'post',
      data
    })
  },
  /**
   * 获取可分配给员工的门店角色以及门店应用数据
   */
  getStaffInfo: data => {
    return axios({
      url: '/protected/account/query',
      method: 'post',
      data
    })
  },
  /**
   * 获取员工权限信息
   */
  getStaffOauth: loginCode => {
    return axios({
      url: `/protected/account/query_account`,
      method: 'post',
      data: {
        loginCode: loginCode
      }
    })
  },
  /**
   * 移出员工
   */
  removeStaff: data => {
    return axios({
      url: '/protected/account/remove',
      method: 'post',
      data
    })
  }
}
